"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventIdSchema = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../../enums");
const utilities_1 = require("../../utilities");
exports.eventIdSchema = yup.object().shape({
    name: yup.string().required().max(15),
    type: yup.string().required().oneOf((0, utilities_1.getEnumValues)(enums_1.CalendarEventTypes)),
    id: yup.string().notRequired(),
    squadronId: yup.string().required(),
    taskId: yup.string().notRequired(),
    aircrewTypeId: yup.string().notRequired(),
    isTrackable: yup.boolean().notRequired(),
    duration: yup
        .string()
        .test('validate-duration', 'Duration should be between 00:00 and 23:00', utilities_1.validateDuration)
        .required(),
    notes: yup.string().notRequired(),
    showTime: yup
        .string()
        .nullable()
        .test('validate-duration', 'Show time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
    briefTime: yup
        .string()
        .nullable()
        .test('validate-duration', 'Brief time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
    stepTime: yup
        .string()
        .nullable()
        .test('validate-duration', 'Step time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
    avgFlightDuration: yup
        .string()
        .nullable()
        .test('validate-duration', 'Avg flight duration should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
});
